import Head from 'components/Head'
import Navbar from 'components/Navbar'
import Footer from 'components/Footer'
import HelpPage from 'components/HelpContainer'
import company from 'config/company.json'
import { withI18nStaticProps } from 'utils/request/ssg'
import {
  NavigationProvider,
  useTranslation,
  CookiesInfo
} from '@sailogy/shipwright'
import { K, i18nPath } from 'i18n/help_cookies'


const CookiesPage: React.FC = () => {
  const t = useTranslation<K>()

  return (
    <NavigationProvider path="/help_cookies">
      <Head
        title={t('Cookies')}
        description={t('%(SITE_NAME)s cares about your privacy: check out our policy.', { SITE_NAME: company.name })}
      />
      <Navbar />
      <HelpPage title={t('Cookies')} active="cookies">
        <CookiesInfo />
      </HelpPage>
      <Footer />
    </NavigationProvider>
  )
}

// Build SSG pages for each language
export const getStaticProps = withI18nStaticProps(i18nPath)

export default CookiesPage
